import { TQualityBand } from '../models'

export const getQualityBand = (score: number): TQualityBand => {
  if (score <= 50) {
    return 'Low'
  }

  if (score <= 80) {
    return 'Moderate'
  }

  return 'High'
}
